module.exports = __webpack_public_path__ + "static/media/image-suv.d31eb8a9.png";